import { NgModule, APP_INITIALIZER, LOCALE_ID, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';

import { BaseModule } from '@bya/base/base.module';
import { AuthModule } from '@bya/auth/auth.module';
import { HomeModule } from './main/home/home.module';

import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { AppConfigService } from './services/app-config/app-config.service';
import { TokenInterceptor } from './services/token-interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { registerLocaleData, CommonModule } from '@angular/common';
import localeEs from '@angular/common/locales/es-CO';
import { GlobalErrorHandler } from '@bya/handlerError/global-error-handler';
import { AppRoutingModule } from './app-routing.module';
import { ByaSharedModule } from './common/bya-shared.module';
import { AccountModule } from '@bya/account/account.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
 
registerLocaleData(localeEs);


@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		CommonModule,
		
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,

		TranslateModule.forRoot(),

		// Material moment date module
		MatMomentDateModule,

		// Material
		MatButtonModule,
		MatIconModule,
		MatToolbarModule,
		MatExpansionModule,
		MatProgressSpinnerModule,
		MatFormFieldModule,
		MatInputModule,
		MatSelectModule,
		MatButtonToggleModule,
		MatDialogModule,

		MatTableModule,
		MatSortModule,
		MatPaginatorModule,
		
		FormsModule,
		ReactiveFormsModule,

		// Fuse modules
		FuseModule.forRoot(fuseConfig),
		FuseProgressBarModule,
		FuseSharedModule,
		FuseSidebarModule,
		FuseThemeOptionsModule,

		// App modules
		LayoutModule,

		//@ByA Seguridad
		BaseModule,
		AuthModule,
		AccountModule,
		HomeModule,
		ByaSharedModule,

		//Routing
		AppRoutingModule

	],
	bootstrap: [
		AppComponent
	],
	entryComponents: [
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true
		},
		{
			provide: APP_INITIALIZER,
			multi: true,
			deps: [AppConfigService],
			useFactory: (appConfigService: AppConfigService) => {
				return () => {
					return appConfigService.loadAppConfig();
				};
			}
		},
		{ provide: LOCALE_ID, useValue: 'es-CO' },
		{ provide: ErrorHandler, useClass: GlobalErrorHandler }
	]
})
export class AppModule {
}